exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1d0zv-YPmo1Ldno5TIUoEa {\n  cursor: pointer;\n  pointer-events: all;\n  color: #FFF; }\n\n._20AZqi0DFj0l7W2MSMC0K {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: #FFF;\n  opacity: .8; }\n\n.k7AdDQ9UeafLwrS3oMDMB {\n  display: none;\n  visibility: hidden; }\n\n.Zhc3tWX4acnrOslNR6TeC {\n  display: block;\n  width: 30px;\n  height: 30px;\n  color: #FFF; }\n\n._3evMdf81zHb9adbp8ayXKg {\n  text-align: center;\n  display: inline-block; }\n\n._1_0YxXFDEW3QGMIEn1l0UW {\n  display: inline-block;\n  width: 3em;\n  height: 3em;\n  border-radius: 50%;\n  border: 3px solid #FFF;\n  border-bottom-color: transparent;\n  background-color: rgba(0, 0, 0, 0.4);\n  animation: _3dUNERw2qIIYEGsihFBEZq 1s linear forwards infinite;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.4); }\n\n._34DF9shkBnJYlpUMBOhf84 {\n  font-size: 1em;\n  margin-top: .4em;\n  padding: .4em 1em;\n  color: #FFF;\n  background-color: rgba(0, 0, 0, 0.4);\n  border-radius: 5px; }\n\n._2VIkdLXXt3VfC7JWCLHXfq {\n  display: none; }\n\n@keyframes _3dUNERw2qIIYEGsihFBEZq {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n", ""]);

// exports
exports.locals = {
	"uiElementActive": "_1d0zv-YPmo1Ldno5TIUoEa",
	"uiElementInactive": "_20AZqi0DFj0l7W2MSMC0K",
	"uiElementHidden": "k7AdDQ9UeafLwrS3oMDMB",
	"svg": "Zhc3tWX4acnrOslNR6TeC",
	"container": "_3evMdf81zHb9adbp8ayXKg",
	"spinner": "_1_0YxXFDEW3QGMIEn1l0UW",
	"spinSpinner": "_3dUNERw2qIIYEGsihFBEZq",
	"message": "_34DF9shkBnJYlpUMBOhf84",
	"hidden": "_2VIkdLXXt3VfC7JWCLHXfq"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/js/standard/Spinner/styles.scss
// module id = 53
// module chunks = 0